export const merge = (arr1: any[], arr2: any[], index = 0): any[] => {
    return arr1.slice(0, index).concat(arr2, arr1.slice(index))
}

export const uniqueListByKey = (arr: any[], key: string) => {
    return arr.filter((v, i, a) => a.findIndex(t => (t[key] === v[key])) === i)
}